import React, { Fragment, useEffect, useState } from "react";
import Button from "../Button/Button";
import axiosInstance from "../../services/api/axiosInstance";
import Cookie from 'js-cookie'
import { Modal } from "react-bootstrap";

const StripePaymentForm = ({ checkOutStatus, cardBtnName, planKey, plan, pricingPlan, cardTitle, planPhase, is_trial_started, pricingResponse, recallFun, subscription_going_to_end }) => {
  const employerPlans = ["Free", "Basic", "Premium", "Platinum"];
  // const partnerPlan = ["Free", "Basic"];
  let enable_downgrading_option_on = 7
  const [plan_in, setPlanIn] = useState(2)
  const [modalName, setModalName] = useState(null)
  const [modelShow, setModelShow] = useState(false)
  const [modalSpinner, setModalSpinner] = useState(false)
  const [is_plan_expired, set_is_plan_expired] = useState(false)
  const [is_plan_cancelled, set_is_plan_cancelled] = useState(false)
  const [paymmentButtonSpinner, setpaymmentButtonSpinner] = useState(false)
  const [paymmentButtonSpinnerName, setpaymmentButtonSpinnerName] = useState(null)
  const [correct_payment_plankey, set_correct_payment_plankey] = useState(null)
  const [current_restricted, set_current_restricted] = useState(null)
  const [downgrading_details, set_downgrading_details] = useState({})

  useEffect(() => {
    let getPlanNum = ''
    let isPlan_expired = checkOutStatus?.paymentStatus === "expired" || checkOutStatus?.paymentStatus === "canceled" || checkOutStatus?.paymentStatus === "cancelled" || checkOutStatus?.productPlan === "beta";

    switch (planPhase) {
      case "Employer":
        if ((checkOutStatus?.paymentStatus === "unpaid" && checkOutStatus?.productPlan === null) ||
          (checkOutStatus?.paymentStatus === "trialing" && checkOutStatus?.productPlan === "Basic") ||
          checkOutStatus?.paymentStatus === "expired" ||
          checkOutStatus?.paymentStatus === "trial_expired" ||
          checkOutStatus?.paymentStatus === "canceled" ||
          checkOutStatus?.paymentStatus === "cancelled" ||
          checkOutStatus?.productPlan === "beta") {

          getPlanNum = 0
        } else {
          getPlanNum = employerPlans?.findIndex((v) => v === pricingPlan)
        }
      //   break;

      // case "Partner":
      //   if ((checkOutStatus?.paymentStatus === "unpaid" && checkOutStatus?.productPlan === null) ||
      //     (checkOutStatus?.paymentStatus === "trialing" && checkOutStatus?.productPlan === "Basic") ||
      //     checkOutStatus?.paymentStatus === "expired" ||
      //     checkOutStatus?.paymentStatus === "trial_expired" ||
      //     checkOutStatus?.paymentStatus === "canceled" ||
      //     checkOutStatus?.paymentStatus === "cancelled" ||
      //     checkOutStatus?.productPlan === "beta") {

      //     getPlanNum = 0
      //   } else {
      //     getPlanNum = partnerPlan?.findIndex((v) => v === pricingPlan)
      //   }
      //   break;

      default:
        break;
    }

    setPlanIn(getPlanNum)
    set_is_plan_expired(isPlan_expired)
    set_is_plan_cancelled(pricingResponse?.is_cancelled === "Y")
  }, [pricingPlan])

  //Choose endpoint
  function chooseEndpoint(btn_name) {
    setpaymmentButtonSpinnerName(btn_name)
    if ((checkOutStatus?.paymentStatus === "unpaid" && (checkOutStatus?.productPlan === "" || checkOutStatus?.productPlan === null)) ||
      checkOutStatus?.paymentStatus === "trialing" && checkOutStatus?.productPlan === "Basic" ||
      checkOutStatus?.paymentStatus === "trial_expired" || checkOutStatus?.paymentStatus === "expired" ||
      checkOutStatus?.paymentStatus === "canceled" ||
      checkOutStatus?.paymentStatus === "cancelled" ||
      checkOutStatus?.productPlan === "beta") {
      return "/upgrade_plan"
    }
    else {
      return "/switch_plan"
    }
  }

  //Payment gateway endpoint
  const checkoutPayment = async (planKey, plan, endpoint) => {
    setModalSpinner(true)
    setpaymmentButtonSpinner(true)
    const createCheckOutParameters = {
      attribute_name: planKey
    }

    try {
      const response = await axiosInstance.post(endpoint, createCheckOutParameters)
      if (response.data.error_code === 0 || response.data.error_code === 200) {
        setModalSpinner(false)
        setpaymmentButtonSpinner(false)
        if (response?.data?.data?.url) window.location.href = response?.data?.data?.url
        else recallFun()
      } else {
        recallFun()
        setModalSpinner(false)
        setpaymmentButtonSpinner(false)
      }
    } catch (err) {
      console.log(err)
      setModalSpinner(false)
      setpaymmentButtonSpinner(false)
    }
  };

  //Cancel subscription endpoint
  const cancelSubscription = async () => {
    try {
      setModalSpinner(true)
      const { data } = await axiosInstance.get("/cancel_subscription")
      if (data?.error_code === 0) {
        recallFun()
        setModelShow(false)
        setModalSpinner(false)
      } else {
        setModalSpinner(false)
      }
    } catch (Err) {
      console.log(Err)
      setModalSpinner(false)
    }
  }

  //Cancel subscription button
  function cancelSubscriptionButton() {
    return <Button
      className={`btn w-100 mt-4 text-primary cancel_subscription ${checkOutStatus.is_cancelled === "N" && !paymmentButtonSpinner ? "" : "pe-none"}`}
      title={checkOutStatus.is_cancelled === "N" ? "Cancel Subscription" : "Subscription Cancelled"}
      buttonType="button"
      functionOnchange={checkOutStatus.is_cancelled === "N" ?
        () => {
          setModalName("cancel_subscription")
          setModelShow(true)
        }
        :
        null
      }
    />
  }

  //Check pricing modal
  function check_pricing(planKey, plan, choosen_plan) {
    const payment_currency = pricingResponse?.payment_currency
    const get_choosenPlan_currency = planKey?.split('_')[planKey?.split('_')?.length - 1]

    if (payment_currency) {
      if (payment_currency === get_choosenPlan_currency) {
        checkoutPayment(planKey, plan, chooseEndpoint(choosen_plan))
      } else {
        set_current_restricted(get_choosenPlan_currency)
        const proceeding_currency_type = planKey?.split('_')
        proceeding_currency_type[proceeding_currency_type?.length - 1] = payment_currency

        const join_proceeding_currency_type = proceeding_currency_type?.join('_')
        setModelShow(true)
        setModalName('invalid_pricing_category')
        set_correct_payment_plankey(join_proceeding_currency_type)
      }
    } else {
      checkoutPayment(planKey, plan, chooseEndpoint(choosen_plan))
    }
  }

  //Downgrade payment 
  function downgrade_payment(planKey, plan, choosen_plan) {
    setModelShow(true)
    setModalName('downgrade_subscription')
    set_downgrading_details({ planKey, plan, choosen_plan })
  }

  function handleProceedDowndrage() {
    check_pricing(
      downgrading_details?.planKey || '',
      downgrading_details?.plan || '',
      downgrading_details?.choosen_plan || ''
    )
  }

  const handleStripeBtn = () => {
    switch (planPhase) {
      case "Employer":
        switch (cardTitle) {
          case 'Free':
            return <Fragment>
              <Button
                className={`btn rounded-pill signUpFree payment-btn px-5 py-3 ${paymmentButtonSpinner ? "btn-brand-color pe-none col-7" : ''} ${is_trial_started === "N" && is_trial_started ? "btn-brand-color" : "btn-disabled btn-secondary pe-none"}`}
                title={
                  paymmentButtonSpinner && paymmentButtonSpinnerName === 'free_tier' ?
                    <span className="spinner-border spinner-border-sm text-outline-dark" role="status"></span>
                    :
                    cardBtnName
                }
                buttonType="button"
                functionOnchange={
                  is_trial_started === "N" ? () => {
                    setpaymmentButtonSpinnerName('free_tier')
                    checkoutPayment(planKey, plan, "/create_checkout_session")
                  }
                    :
                    null
                }
              />
            </Fragment>

          case 'Basic':
            return <Fragment>
              <Button
                buttonType="button"
                className={`btn rounded-pill signUpFree payment-btn px-5 py-3 ${paymmentButtonSpinner ?
                  "btn-brand-color pe-none col-7"
                  :
                  subscription_going_to_end < 1 || is_plan_expired || plan_in === 0 ?
                    "btn-brand-color"
                    :
                    plan_in === 1 ?
                      "btn-brand-color-pricing-plan pe-none"
                      :
                      is_plan_cancelled ?
                        "btn-disabled btn-secondary pe-none"
                        :
                        subscription_going_to_end > enable_downgrading_option_on && plan_in > 1 ?
                          "btn-disabled btn-secondary pe-none"
                          :
                          "btn-brand-color"
                  }`
                }
                title={
                  paymmentButtonSpinner && paymmentButtonSpinnerName === 'Basic' ?
                    <span className="spinner-border spinner-border-sm text-outline-dark" role="status"></span>
                    :
                    subscription_going_to_end < 1 || is_plan_expired || plan_in === 0 ?
                      "Subscribe"
                      :
                      plan_in === 1 ?
                        "Subscribed"
                        :
                        "Downgrade"
                }
                functionOnchange={subscription_going_to_end < 1 || is_plan_expired || plan_in === 0 ?
                  () => check_pricing(planKey, plan, 'Basic')
                  :
                  plan_in === 1 ?
                    null
                    :
                    () => downgrade_payment(planKey, plan, 'Basic')
                }
              />

              {plan_in === 1 && subscription_going_to_end ? cancelSubscriptionButton() : null}
            </Fragment>

          case 'Premium':
            return <Fragment>
              <Button
                buttonType="button"
                className={`btn rounded-pill signUpFree payment-btn px-5 py-3 ${paymmentButtonSpinner ?
                  "btn-brand-color pe-none col-7"
                  :
                  subscription_going_to_end < 1 || is_plan_expired || plan_in === 0 ?
                    "btn-brand-color"
                    :
                    plan_in === 2 ?
                      "btn-brand-color-pricing-plan pe-none"
                      :
                      is_plan_cancelled ?
                        "btn-disabled btn-secondary pe-none"
                        :
                        subscription_going_to_end > enable_downgrading_option_on && plan_in > 2 ?
                          "btn-disabled btn-secondary pe-none"
                          :
                          "btn-brand-color"
                  }`
                }
                title={
                  paymmentButtonSpinner && paymmentButtonSpinnerName === 'Basic' ?
                    <span className="spinner-border spinner-border-sm text-outline-dark" role="status"></span>
                    :
                    subscription_going_to_end < 1 || is_plan_expired || plan_in === 0 ?
                      "Subscribe"
                      :
                      plan_in === 2 ?
                        "Subscribed"
                        :
                        plan_in > 2 ?
                          "Downgrade"
                          :
                          "Upgrade"
                }
                functionOnchange={subscription_going_to_end < 1 || is_plan_expired || plan_in === 0 ?
                  () => check_pricing(planKey, plan, 'Basic')
                  :
                  plan_in < 2 ?
                    () => check_pricing(planKey, plan, 'Basic')
                    :
                    () => downgrade_payment(planKey, plan, 'Basic')
                }
              />

              {plan_in === 2 && subscription_going_to_end ? cancelSubscriptionButton() : null}
            </Fragment>

          case 'Platinum':
            return <Fragment>
              <Button
                buttonType="button"
                className={`btn rounded-pill signUpFree payment-btn px-5 py-3 ${paymmentButtonSpinner ?
                  "btn-brand-color pe-none col-7"
                  :
                  subscription_going_to_end < 1 || is_plan_expired || plan_in === 0 ?
                    "btn-brand-color"
                    :
                    plan_in === 3 ?
                      "btn-brand-color-pricing-plan pe-none"
                      :
                      is_plan_cancelled ?
                        "btn-disabled btn-secondary pe-none"
                        :
                        "btn-brand-color"
                  }`
                }
                title={
                  paymmentButtonSpinner && paymmentButtonSpinnerName === 'Basic' ?
                    <span className="spinner-border spinner-border-sm text-outline-dark" role="status"></span>
                    :
                    subscription_going_to_end < 1 || is_plan_expired || plan_in === 0 ?
                      "Subscribe"
                      :
                      plan_in === 3 ?
                        "Subscribed"
                        :
                        "Upgrade"
                }
                functionOnchange={() => check_pricing(planKey, plan, 'Basic')}
              />

              {plan_in === 3 && subscription_going_to_end ? cancelSubscriptionButton() : null}
            </Fragment>

          default:
            break;
        }

      // case "Partner":
      //   switch (cardTitle) {
      //     case "Free":
      //       return <Fragment>
      //         <Button
      //           className={`btn rounded-pill signUpFree payment-btn px-5 py-3 ${paymmentButtonSpinner ? "btn-brand-color pe-none col-7" : ''} ${is_trial_started === "N" && is_trial_started ? "btn-brand-color" : "btn-disabled btn-secondary pe-none"}`}
      //           title={
      //             paymmentButtonSpinner && paymmentButtonSpinnerName === 'free_tier' ?
      //               <span className="spinner-border spinner-border-sm text-outline-dark" role="status"></span>
      //               :
      //               cardBtnName
      //           }
      //           buttonType="button"
      //           functionOnchange={
      //             is_trial_started === "N" ? () => {
      //               setpaymmentButtonSpinnerName('free_tier')
      //               checkoutPayment(planKey, plan, "/create_checkout_session")
      //             }
      //               :
      //               null
      //           }
      //         />
      //       </Fragment>

      //     case 'Basic':
      //       return <Fragment>
      //         <Button
      //           buttonType="button"
      //           className={`btn rounded-pill signUpFree payment-btn px-5 py-3 ${paymmentButtonSpinner ?
      //             "btn-brand-color pe-none col-7"
      //             :
      //             subscription_going_to_end < 1 || is_plan_expired || plan_in === 0 ?
      //               "btn-brand-color"
      //               :
      //               plan_in === 1 ?
      //                 "btn-brand-color-pricing-plan pe-none"
      //                 :
      //                 is_plan_cancelled ?
      //                   "btn-disabled btn-secondary pe-none"
      //                   :
      //                   subscription_going_to_end > enable_downgrading_option_on && plan_in > 1 ?
      //                     "btn-disabled btn-secondary pe-none"
      //                     :
      //                     "btn-brand-color"
      //             }`
      //           }
      //           title={
      //             paymmentButtonSpinner && paymmentButtonSpinnerName === 'Basic' ?
      //               <span className="spinner-border spinner-border-sm text-outline-dark" role="status"></span>
      //               :
      //               subscription_going_to_end < 1 || is_plan_expired || plan_in === 0 ?
      //                 "Subscribe"
      //                 :
      //                 plan_in === 1 ?
      //                   "Subscribed"
      //                   :
      //                   "Downgrade"
      //           }
      //           functionOnchange={subscription_going_to_end < 1 || is_plan_expired || plan_in === 0 ?
      //             () => check_pricing(planKey, plan, 'Basic')
      //             :
      //             plan_in === 1 ?
      //               null
      //               :
      //               () => downgrade_payment(planKey, plan, 'Basic')
      //           }
      //         />

      //         {plan_in === 1 && subscription_going_to_end ? cancelSubscriptionButton() : null}
      //       </Fragment>


      //     default:
      //       break;

      case "Partner":
        switch (cardTitle) {
          case 'Basic':
            return <Button
              className={`btn rounded-pill signUpFree payment-btn px-5 py-3 ${Cookie.get("subscriptionExpired") ? !process.env.REACT_APP_EXPIRED_PARTNER_PRICING_PLAN.includes("Basic") : !process.env.REACT_APP_ALLOW_PARTNER_PRICING_PLAN.includes("Basic") ? "btn-disabled btn-secondary" : "btn-brand-color"}`}
              title={cardBtnName}
              buttonType="button"
              functionOnchange={(Cookie.get("subscriptionExpired") ? !process.env.REACT_APP_EXPIRED_PARTNER_PRICING_PLAN.includes("Basic") : !process.env.REACT_APP_ALLOW_PARTNER_PRICING_PLAN.includes("Basic")) ? null : () => checkoutPayment(planKey, plan)}
            />

          case 'Premium':
            return <Button
              className={`btn rounded-pill signUpFree payment-btn px-5 py-3 ${Cookie.get("subscriptionExpired") ? !process.env.REACT_APP_EXPIRED_PARTNER_PRICING_PLAN.includes("Premium") : !process.env.REACT_APP_ALLOW_PARTNER_PRICING_PLAN.includes("Premium") ? "btn-disabled btn-secondary" : "btn-brand-color"}`}
              title={cardBtnName}
              buttonType="button"
              functionOnchange={(Cookie.get("subscriptionExpired") ? !process.env.REACT_APP_EXPIRED_PARTNER_PRICING_PLAN.includes("Premium") : !process.env.REACT_APP_ALLOW_PARTNER_PRICING_PLAN.includes("Premium")) ? null : () => checkoutPayment(planKey, plan)}
            />

          case 'Platinum':
            return <Button
              className={`btn rounded-pill signUpFree payment-btn px-5 py-3 ${(Cookie.get("subscriptionExpired") ? !process.env.REACT_APP_EXPIRED_PARTNER_PRICING_PLAN.includes("Platinum") : !process.env.REACT_APP_ALLOW_PARTNER_PRICING_PLAN.includes("Platinum")) ? "btn-disabled btn-secondary" : "btn-brand-color"}`}
              title={cardBtnName}
              buttonType="button"
              functionOnchange={(Cookie.get("subscriptionExpired") ? !process.env.REACT_APP_EXPIRED_PARTNER_PRICING_PLAN.includes("Platinum") : !process.env.REACT_APP_ALLOW_PARTNER_PRICING_PLAN.includes("Platinum")) ? null : () => checkoutPayment(planKey, plan)}
            />

          default:
            break;
        }

      case "Professional":
        switch (cardTitle) {
          case 'Basic':
            return <Button
              className={`btn rounded-pill signUpFree payment-btn px-5 py-3 ${(Cookie.get("subscriptionExpired") ? !process.env.REACT_APP_EXPIRED_PROFESSIONAL_PRICING_PLAN.includes("Basic") : !process.env.REACT_APP_ALLOW_PROFESSIONAL_PRICING_PLAN.includes("Basic")) ? "btn-disabled btn-secondary" : "btn-brand-color"}`}
              title={cardBtnName}
              buttonType="button"
              functionOnchange={(Cookie.get("subscriptionExpired") ? !process.env.REACT_APP_EXPIRED_PROFESSIONAL_PRICING_PLAN.includes("Basic") : !process.env.REACT_APP_ALLOW_PROFESSIONAL_PRICING_PLAN.includes("Basic")) ? null : () => checkoutPayment(planKey, plan)}
            />

          case 'Premium':
            return <Button
              className={`btn rounded-pill signUpFree payment-btn px-5 py-3 ${(Cookie.get("subscriptionExpired") ? !process.env.REACT_APP_EXPIRED_PROFESSIONAL_PRICING_PLAN.includes("Premium") : !process.env.REACT_APP_ALLOW_PROFESSIONAL_PRICING_PLAN.includes("Premium")) ? "btn-disabled btn-secondary" : "btn-brand-color"}`}
              title={cardBtnName}
              buttonType="button"
              functionOnchange={(Cookie.get("subscriptionExpired") ? !process.env.REACT_APP_EXPIRED_PROFESSIONAL_PRICING_PLAN.includes("Premium") : !process.env.REACT_APP_ALLOW_PROFESSIONAL_PRICING_PLAN.includes("Premium")) ? null : () => checkoutPayment(planKey, plan)}
            />

          case 'Platinum':
            return <Button
              className={`btn rounded-pill signUpFree payment-btn px-5 py-3  ${(Cookie.get("subscriptionExpired") ? !process.env.REACT_APP_EXPIRED_PROFESSIONAL_PRICING_PLAN.includes("Platinum") : !process.env.REACT_APP_ALLOW_PROFESSIONAL_PRICING_PLAN.includes("Platinum")) ? "btn-disabled btn-secondary" : "btn-brand-color"}`}
              title={cardBtnName}
              buttonType="button"
              functionOnchange={(Cookie.get("subscriptionExpired") ? !process.env.REACT_APP_EXPIRED_PROFESSIONAL_PRICING_PLAN.includes("Platinum") : !process.env.REACT_APP_ALLOW_PROFESSIONAL_PRICING_PLAN.includes("Platinum")) ? null : () => checkoutPayment(planKey, plan)}
            />

          default:
            break;
        }
    }
  }

  function modalDynamicBody() {
    switch (modalName) {
      case "cancel_subscription":
        return <div className=" px-2 col-12">
          <div className="row justify-content-center col-12 text-center">
            <div className="col-6 text-center">
              <img src={`${process.env.REACT_APP_SECOND_CAREERS_CDN}subscription-expired.png`} alt='subscription expired' with={135} height={135} />
            </div>
            <div className="col-12">
              <h5 className="py-3">Are you sure you want to cancel your subscription?</h5>
              <p className="mb-2">Upon cancellation, you will retain full access until the end of your current billing period. After this, your subscription will not renew automatically, and access will no longer be available.</p>
            </div>
          </div>
        </div>

      case "downgrade_subscription":
        return <div className=" px-2 col-12">
          <div className="row justify-content-center col-12 text-center">
            <div className="col-6 text-center">
              <img src={`${process.env.REACT_APP_SECOND_CAREERS_CDN}subscription-expired.png`} alt='subscription expired' with={135} height={135} />
            </div>
            <div className="col-12">
              <h4 className="py-4">Are you sure do you want to downgrade your subscription ?</h4>

              {/* <p className="mb-2">To continue utilizing our platform effectively, you'll need to upgrade your plan. Upgrading will give you access to all our features and services without interruption.</p> */}
            </div>
          </div>
        </div>

      case "invalid_pricing_category":
        return <div className=" px-2 col-12">
          <div className="row justify-content-center col-12 text-center">
            <div className="col-6 text-center">
              <img src={`${process.env.REACT_APP_SECOND_CAREERS_CDN}subscription-expired.png`} alt='subscription expired' with={135} height={135} />
            </div>
            <div className="col-12">
              <h4 className="py-4">Payment Currency Restriction</h4>
              <p className="mb-2">Your last payment was made in <b>{pricingResponse?.payment_currency?.toUpperCase()}</b>, so you cannot proceed with <b>{current_restricted?.toUpperCase()}</b> now.
                Please click the 'Continue' button to complete the payment in <b>{pricingResponse?.payment_currency?.toUpperCase()}</b>.</p>
            </div>
          </div>
        </div>

      default:
        break;
    }
  }

  function modalDynamicFooter() {
    switch (modalName) {
      case "cancel_subscription":
        return <Fragment>
          <div className="col">
            <button type="button" className={`btn btn-secondary w-100 py-2 ${modalSpinner ? "pe-none opacity-75" : ""}`} onClick={() => setModelShow(false)}>
              Cancel
            </button>
          </div>
          <div className="col">
            <button type="button" className={`btn btn-brand-color w-100 py-2 ${modalSpinner ? "pe-none opacity-75" : ""}`} onClick={cancelSubscription} >
              {
                modalSpinner ?
                  <span className="spinner-border spinner-border-sm text-outline-dark" role="status"></span>
                  :
                  "Proceed"
              }
            </button>
          </div>
        </Fragment>

      case "downgrade_subscription":
        return <Fragment>
          <div className="col">
            <button type="button" className={`btn btn-secondary w-100 py-2 ${modalSpinner ? "pe-none opacity-75" : ""}`} onClick={() => setModelShow(false)}>
              Cancel
            </button>
          </div>
          <div className="col">
            <button type="button" className={`btn btn-brand-color w-100 py-2 ${modalSpinner ? "pe-none opacity-75" : ""}`} onClick={handleProceedDowndrage} >
              {
                modalSpinner ?
                  <span className="spinner-border spinner-border-sm text-outline-dark" role="status"></span>
                  :
                  "Proceed"
              }
            </button>
          </div>
        </Fragment>

      case "invalid_pricing_category":
        return <Fragment>
          <div className="col">
            <button type="button" className={`btn btn-secondary w-100 py-2 ${modalSpinner ? "pe-none opacity-75" : ""}`} onClick={() => setModelShow(false)}>
              Cancel
            </button>
          </div>
          <div className="col">
            <button type="button" className={`btn btn-brand-color w-100 py-2 ${modalSpinner ? "pe-none opacity-75" : ""}`} onClick={() => checkoutPayment(correct_payment_plankey, plan, chooseEndpoint())} >
              {
                modalSpinner ?
                  <span className="spinner-border spinner-border-sm text-outline-dark" role="status"></span>
                  :
                  "Continue"
              }
            </button>
          </div>
        </Fragment>

      default:
        break;
    }
  }

  return (
    <form>
      {handleStripeBtn()}


      {/*cancel subscription modal  */}
      <Modal
        show={modelShow}
        backdrop="static"
        keyboard={false}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        contentClassName="rounded-4"
        onHide={() => setModelShow(false)}
      >
        <Modal.Header className="border-0" closeButton />
        <Modal.Body>
          {modalDynamicBody()}
        </Modal.Body>
        <Modal.Footer className="border-0">
          {modalDynamicFooter()}
        </Modal.Footer>
      </Modal>

    </form>
  );
};

export default StripePaymentForm;
